import { BASE_SERVICE_URI } from '../../constants/ApiConstants';
import { quickFetchOrGet } from '../../utils/ajaxUtils';
import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { useCallback } from 'react';
import Raven from 'raven-js';
import { useRecommendationsState } from './recommendationsStore';
import { usePostRankedRecommendationsContentEngagedFeedback } from 'academy-common-lib/features/recommendations/hooks/usePostRankedRecommendationsContentEngagedFeedback';
export const GET_RECOMMENDATIONS_TOPIC_PREFERENCE = registerQuery({
  fieldName: 'recommendationsTopicPreference',
  args: [],
  fetcher() {
    return quickFetchOrGet('topic-preferences', `${BASE_SERVICE_URI}/recommendations/v1/topic-preferences`);
  }
});
export const getRecommendationsTopicPreference = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_RECOMMENDATIONS_TOPIC_PREFERENCE
  });
};
export const useRecommendationsTopicPreference = () => {
  const {
    data: recommendationsTopicPreference,
    loading: recommendationsTopicPreferenceLoading,
    error: recommendationsTopicPreferenceError
  } = useQuery(GET_RECOMMENDATIONS_TOPIC_PREFERENCE);
  return {
    recommendationsTopicPreference,
    recommendationsTopicPreferenceLoading,
    recommendationsTopicPreferenceError
  };
};
export const usePostRecommendationsContentEngagedFeedback = () => {
  const {
    clearLastClickedRecommendationItem,
    lastClickedRecommendationItem
  } = useRecommendationsState();
  const {
    postRankedRecommendationsContentEngagedFeedback,
    postRankedRecommendationsContentEngagedFeedbackError,
    postRankedRecommendationsContentEngagedFeedbackLoading
  } = usePostRankedRecommendationsContentEngagedFeedback();
  const postRecommendationsContentEngagedFeedback = useCallback(({
    item,
    contentId
  }) => {
    // do not send feedback if there is no last clicked recommendation item or if it doesn't match the current item
    if (!lastClickedRecommendationItem || lastClickedRecommendationItem.item.id !== item.id || lastClickedRecommendationItem.item.type !== item.type) return;
    return postRankedRecommendationsContentEngagedFeedback({
      correlationId: lastClickedRecommendationItem.correlationId,
      contentContainerType: item.type,
      resultId: item.id,
      engagedContentId: contentId
    }).catch(Raven.captureException.bind(Raven)).finally(() => {
      clearLastClickedRecommendationItem();
    });
  }, [clearLastClickedRecommendationItem, lastClickedRecommendationItem, postRankedRecommendationsContentEngagedFeedback]);
  return {
    postRecommendationsContentEngagedFeedback,
    postRecommendationsContentEngagedFeedbackError: postRankedRecommendationsContentEngagedFeedbackError,
    postRecommendationsContentEngagedFeedbackLoading: postRankedRecommendationsContentEngagedFeedbackLoading
  };
};